import PropTypes from "prop-types";
import React from "react";

/**
 * @param   {Number} width
 * @param   {String} backgroundColor
 * @returns {ReactElement}
 */
export default function SidebarTooltipArrowUp({ color, borderColor, ...props }) {
  return (
    <div
      {...props}
      css={{
        position: "absolute",
        top: -20,

        "&::before, &::after": {
          position: "absolute",
          border: "1px solid transparent",
          content: " ",
          height: 0,
          width: 0,
          pointerEvents: "none",
          borderColor: "rgba(255, 255, 255, 0)",
          borderBottomColor: "#ffffff",
        },

        ":after": {
          borderColor: "transparent",
          borderBottomColor: color,
          marginLeft: -11,
          borderWidth: 11,
        },

        ":before": {
          borderColor: "transparent",
          borderBottomColor: borderColor,
          borderWidth: 10,
          marginLeft: -10,
        },
      }}
    />
  );
}

SidebarTooltipArrowUp.propTypes = {
  width: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
};
